module.exports = __webpack_public_path__ + "static/media/plan-wom-400gb-wom50.b1c4265b.svg";